import { UniqueIdentifier } from '@dnd-kit/core';

export type MapDragEntity =
  | { kind: 'host'; id: number }
  | { kind: 'object'; id: number };

export const hostDragId = (id: number): string => `host:${id}`;
export const objectDragId = (id: number): string => `object:${id}`;

export const parseMapDragId = (
  value: UniqueIdentifier | null | undefined
): MapDragEntity | null => {
  if (typeof value !== 'string') return null;
  const [kind, rawId] = value.split(':');
  const id = Number(rawId);
  if (!Number.isInteger(id) || id < 0) return null;
  if (kind === 'host' || kind === 'object') return { kind, id };
  return null;
};

export const isMapEntityActive = (
  activeId: UniqueIdentifier | null | undefined,
  kind: MapDragEntity['kind'],
  id: number | null | undefined
): boolean => {
  const parsed = parseMapDragId(activeId);
  return parsed?.kind === kind && parsed.id === id;
};
